// @vendors
import { useContext, useEffect } from "react"
import { Form, Radio } from 'antd'
import Context from '../../../context/appContext';
import { getDependencyValue } from '../../../utils/utils';

export default function RadioText({ info, key, form, current }) {

    const validate = info.validate ? info.validate : {};
    const { dataForm: { data, formResponses, hiddenFields, disabledFields }, setDataForm } = useContext(Context);

    useEffect(() => {
        getDefaultValue();
    }, []);

    useEffect(() => {
        if (info && info.key === 'tipoDePersonaContratante' && hiddenFields[info.key]) {
            info.value = '';
            const index = formResponses.findIndex(x => x.key === info.key);
            formResponses[index].value = '';
        }
        getDefaultValue();
    }, [hiddenFields[info.key]]);

    const onChange = (event) => {
        setValue(event);
        const dependencyValue = getDependencyValue(current, info.key, event.target.value, []);
        if (dependencyValue && dependencyValue.length > 0) {
            dependencyValue.forEach(item => {
                const keyLcl = Object.keys(item)[0];
                form.setFieldsValue({ [keyLcl]: '' });
                hiddenFields[keyLcl] = keyLcl === 'otrasNacionalidadesContratante' ||
                    keyLcl === 'residenteFiscalExtranjeroContratante' ? true : item[keyLcl];
            });
            setDataForm({ data, formResponses, hiddenFields: hiddenFields, disabledFields });
        }

        //Limpiar rfc de persona Moral o Fisica para evitar problema de que estaba enviando RFC incorrecto al momento de validar 
        if (info.key == "tipoDePersonaContratante") {
            var newFormResponse = [];
            if (info.value == "personaMoral") {
                newFormResponse = formResponses.filter(x => x.key != "identificadorPersonaContratante");
            }
            else {
                newFormResponse = formResponses.filter(x => x.key != "identificadorPersonaContratanteMoral");
            }
            setDataForm({ data, formResponses: newFormResponse, hiddenFields: hiddenFields, disabledFields });
        }
    }

    const setValue = (event) => {
        info.value = event.target.value;
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = event.target.value : formResponses.push(info);
    }

    const getDefaultValue = () => {
        if (info && info.value && info.value !== null && info.value !== '') {
            form.setFieldsValue({ [info.key]: info.value });
            onChange({ target: { value: info.value } });
        } else {
            const index = formResponses.findIndex(x => x.key === info.key);
            let value = index != -1 ? formResponses[index].value : '';
            value = value ? value : info.defaultValue;
            form.setFieldsValue({ [info.key]: value });
            onChange({ target: { value: value } });

        }
    }

    return (
        <Form.Item
            className='ant-form-item-normal'
            label={info.label}
            name={info.key}
            key={key}
            hidden={hiddenFields[info.key]}
            rules={[
                {
                    required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                    message: 'Este campo es requerido'
                }
            ]}
        >
            <Radio.Group
                className='ant-radio-inline'
                disabled={disabledFields[info.key]}
                onChange={onChange}
            >
                {info && info.values.map((item, index) => (
                    <Radio
                        value={item.value}
                        key={`radio-option-${index}`}
                        data-testid={`radio-option-${index}`}
                    >
                        {item.label}
                    </Radio>
                ))}
            </Radio.Group>
        </Form.Item>
    )
}